// src/Components/HPC_Report/secondary_report/CoverPages.jsx
import React from 'react';
import foundationalFirst from '../../../../Assets/Foundational_cover_1.png';
import foundationalSecond from '../../../../Assets/Foundational_cover_2.png';
import foundationalThird from '../../../../Assets/Foundational_cover_3.png';
import foundationalFourth from '../../../../Assets/secondary_cover_4.png';

// Cover Page 1 - Using Foundation images for now (will be replaced with Secondary stage images)
export const CoverPage1 = () => (
    <div className="report-page" style={{
        width: '210mm',
        height: '297mm',
        minHeight: '297mm',
        padding: '0',
        margin: '0 auto',
        boxSizing: 'border-box',
        overflow: 'hidden',
        display: 'block',
        border: 'none',
        outline: 'none',
        background: 'none'
    }}>
        <img
            src={foundationalFirst}
            alt="Secondary-Cover-Page-1"
            style={{
                width: '100%',
                height: '100%',
                objectFit: 'fill',
                objectPosition: 'center'
            }}
            onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'flex';
            }}
        />
        <div style={{display: 'none'}} className="w-full h-full bg-gray-200 flex items-center justify-center">
            <div className="text-center text-gray-500">
                <div className="text-2xl mb-2">📄</div>
                <div>Secondary Cover Page 1</div>
                <div className="text-sm">Image not found</div>
            </div>
        </div>
    </div>
);

// Cover Page 2 - Using Foundation images for now (will be replaced with Secondary stage images)
export const CoverPage2 = () => (
    <div className="report-page" style={{
        width: '210mm',
        height: '297mm',
        minHeight: '297mm',
        padding: '0',
        margin: '0 auto',
        boxSizing: 'border-box',
        overflow: 'hidden',
        display: 'block',
        border: 'none',
        outline: 'none',
        background: 'none'
    }}>
        <img
            src={foundationalSecond}
            alt="Secondary-Cover-Page-2"
            style={{
                width: '100%',
                height: '100%',
                objectFit: 'fill',
                objectPosition: 'center'
            }}
            onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'flex';
            }}
        />
        <div style={{display: 'none'}} className="w-full h-full bg-gray-200 flex items-center justify-center">
            <div className="text-center text-gray-500">
                <div className="text-2xl mb-2">📄</div>
                <div>Secondary Cover Page 2</div>
                <div className="text-sm">Image not found</div>
            </div>
        </div>
    </div>
);

// Cover Page 3 - Using Foundation images for now (will be replaced with Secondary stage images)
export const CoverPage3 = () => (
    <div className="report-page" style={{
        width: '210mm',
        height: '297mm',
        minHeight: '297mm',
        padding: '0',
        margin: '0 auto',
        boxSizing: 'border-box',
        overflow: 'hidden',
        display: 'block',
        border: 'none',
        outline: 'none',
        background: 'none'
    }}>
        <img
            src={foundationalThird}
            alt="Secondary-Cover-Page-3"
            style={{
                width: '100%',
                height: '100%',
                objectFit: 'fill',
                objectPosition: 'center'
            }}
            onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'flex';
            }}
        />
        <div style={{display: 'none'}} className="w-full h-full bg-gray-200 flex items-center justify-center">
            <div className="text-center text-gray-500">
                <div className="text-2xl mb-2">📄</div>
                <div>Secondary Cover Page 3</div>
                <div className="text-sm">Image not found</div>
            </div>
        </div>
    </div>
);

// Cover Page 4 - Using Foundation images for now (will be replaced with Secondary stage images)
export const CoverPage4 = () => (
    <div className="report-page" style={{
        width: '210mm',
        height: '297mm',
        minHeight: '297mm',
        padding: '0',
        margin: '0 auto',
        boxSizing: 'border-box',
        overflow: 'hidden',
        display: 'block',
        border: 'none',
        outline: 'none',
        background: 'none'
    }}>
        <img
            src={foundationalFourth}
            alt="Secondary-Cover-Page-4"
            style={{
                width: '100%',
                height: '100%',
                objectFit: 'fill',
                objectPosition: 'center'
            }}
            onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'flex';
            }}
        />
        <div style={{display: 'none'}} className="w-full h-full bg-gray-200 flex items-center justify-center">
            <div className="text-center text-gray-500">
                <div className="text-2xl mb-2">📄</div>
                <div>Secondary Cover Page 4</div>
                <div className="text-sm">Image not found</div>
            </div>
        </div>
    </div>
);

export default CoverPage1;